const whitelisted_paths  = ['/', '/login', '/signup', '/verifyemail', '/docs'];
const base_url = "https://api.wapi.50chats.com"
export {
    whitelisted_paths,
    base_url
}
